import { render, staticRenderFns } from "./OrderHistory-company.vue?vue&type=template&id=bd7f65ca&scoped=true"
import script from "./OrderHistory-company.vue?vue&type=script&lang=js"
export * from "./OrderHistory-company.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory-company.vue?vue&type=style&index=0&id=bd7f65ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7f65ca",
  null
  
)

export default component.exports